"use client";

import { RiArrowLeftLine, RiMapPinLine } from "@remixicon/react";
import { Button } from "@workspace/ui/components/button";
import { useRouter } from "next/navigation";

export default function NotFound() {
	const router = useRouter();

	return (
		<div className="flex min-h-screen flex-col items-center justify-center px-4">
			<div className="text-center">
				<RiMapPinLine className="mx-auto mb-4 h-16 w-16 text-primary" />
				<h1 className="mb-2 font-semibold text-2xl">Lost in the Crowd</h1>
				<p className="mb-8 text-muted-foreground">
					This set has ended or the stage has moved.
				</p>
				<Button onClick={() => router.back()}>
					<RiArrowLeftLine className="h-4 w-4" />
					Go Back
				</Button>
			</div>
		</div>
	);
}
